module.exports = __webpack_public_path__ + "static/media/box.d8fc458e.svg";